import React, { useRef } from 'react';
import TableFilterDatePicker from './InputFields/TableFilterDatePicker';
import TableFilterTextBox from './InputFields/TableFilterTextBox';
import TableFilterDropdown from './InputFields/TableFilterDropdown';

export enum FieldType {
  DATE = 'date',
  TEXTBOX = 'textbox',
  DROPDOWN = 'dropdown'
}

const TableFilterInputField = ({ field,  filterConfiguration, onChange }) => {
  const inputRef = useRef();
  const inputFieldType = filterConfiguration[field].fieldType;

  if (inputFieldType === FieldType.TEXTBOX) {
    const mask = filterConfiguration[field]?.mask;
    return <TableFilterTextBox mask={mask} onChange={onChange} field={field} inputRef={inputRef} />;
  }
  if (inputFieldType === FieldType.DROPDOWN) {
    const labelOptionsSelector = filterConfiguration[field].optionsLabelSelector;
    const options = filterConfiguration[field].options;
    return (
      <TableFilterDropdown
        onChange={onChange}
        field={field}
        options={options}
        optionsLabelSelector={labelOptionsSelector}
      />
    );
  }
  return <TableFilterDatePicker onChange={onChange} field={field}  inputRef={inputRef} />;
};

export default TableFilterInputField;
